module.exports = __webpack_public_path__ + "img/pr-2.a0687d1b.png";